import {
  ProfileEmployeeLocationEmployeesLocationFragment,
  ProfileEmployeeLocationFragment,
} from 'generated/resources/graphql'

import { Box, List, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import EmployeeWorkplacesListItem from 'modules/profile/components/Workplaces/EmployeeWorkplacesListItem'

interface Props {
  employeeId: string
  accessId: string
  employeeLocations: ProfileEmployeeLocationEmployeesLocationFragment[]
  companyLocations: ProfileEmployeeLocationFragment[]
  defaultLocationId: string | null
  canAssignLocations: boolean
  onDefaultLocationUpdated: (id: string) => void
}

const EmployeeWorkplacesList = ({
  employeeId,
  accessId,
  defaultLocationId,
  employeeLocations,
  companyLocations,
  canAssignLocations,
  onDefaultLocationUpdated,
}: Props) => {
  const defaultLocation =
    defaultLocationId != null
      ? employeeLocations.find((location) => defaultLocationId == location?.location?.id)
      : undefined

  const defaultWorkArea = defaultLocation?.employeesLocationWorkAreas?.find(
    (workArea) => workArea.isDefault
  )

  return (
    <List>
      {defaultLocation && defaultLocation?.location?.id && (
        <EmployeeWorkplacesListItem
          locationName={defaultLocation?.location?.name}
          isLocationDefault
          employeeId={employeeId}
          accessId={accessId}
          locationId={defaultLocation?.location?.id}
          canAssignLocations={canAssignLocations}
          defaultWorkArea={defaultWorkArea}
          onDefaultLocationUpdated={onDefaultLocationUpdated}
          employeeLocations={employeeLocations}
          companyLocations={companyLocations}
          employeesLocation={defaultLocation}
        />
      )}
      {employeeLocations.map((employeeLocation) => {
        const isLocationDefault = defaultLocation == employeeLocation
        if (isLocationDefault) return
        if (!employeeLocation?.location?.id) return

        const location = employeeLocation?.location

        return (
          <EmployeeWorkplacesListItem
            key={location.id}
            locationName={location.name}
            isLocationDefault={isLocationDefault}
            employeeId={employeeId}
            accessId={accessId}
            locationId={location.id}
            canAssignLocations={canAssignLocations}
            companyLocations={companyLocations}
            employeeLocations={employeeLocations}
            onDefaultLocationUpdated={onDefaultLocationUpdated}
            employeesLocation={employeeLocation}
          />
        )
      })}

      {employeeLocations.length === 0 && (
        <List.Item>
          <Box
            flexDirection="row"
            alignItems="center"
            width="full"
            justifyContent="spaceBetween"
            gap="s24"
          >
            <Text color="grey800" weight="normal" size="200">
              {i18n.t('employee_form.workplaces.no_workplaces')}
            </Text>
          </Box>
        </List.Item>
      )}
    </List>
  )
}

export default EmployeeWorkplacesList
